export default { sha: '12a6812e02fc0627e8ed1377b294157df30daf5b', buildNumber: 'undefined' }
